import * as React from 'react';
import classNamesFn from 'clsx';
import { getDataAttributes } from '@wix/editor-elements-common-utils';
import type { FreemiumBannerMobileCommonProps } from '../FreemiumBannerMobile.types';
import Link from '../../../Link/viewer/Link';
import { TestIds } from '../../common/constants';
import { AppsNames } from './constants';
import PreferredAppContent from './PreferredAppContent';

const defaultDirection = 'ltr';

const FreemiumBannerMobileCommon: React.FC<
  FreemiumBannerMobileCommonProps
> = props => {
  const {
    id = 'WIX_ADS',
    translations,
    useOverlay = false,
    href = '',
    className,
    classNames = [defaultDirection],
    onBannerLoad = () => {},
    onBannerClicked = () => {},
    shouldReportBi = false,
    getPreferredApp,
    shouldUsePreferredApp,
    children,
    styles,
  } = props;

  const [preferredApp, setPreferredApp] = React.useState<string | undefined>(
    undefined,
  );

  const anchorClassNames = classNamesFn(
    ...classNames.map(name => styles[name]),
    styles.mobileTop,
    'has-custom-focus',
  );

  React.useEffect(() => {
    if (shouldUsePreferredApp) {
      getPreferredApp()
        .then(preferredAppRes =>
          setPreferredApp(
            preferredAppRes.ownerPreferredApp || AppsNames.Default,
          ),
        )
        .catch(() => setPreferredApp(AppsNames.Default));
    }
  }, [getPreferredApp, shouldUsePreferredApp]);

  React.useEffect(() => {
    if (shouldReportBi) {
      onBannerLoad();
    }
  }, [onBannerLoad, shouldReportBi]);

  return !shouldUsePreferredApp || preferredApp !== undefined ? (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNamesFn(className, styles.mobile, styles.freemiumBanner)}
    >
      {useOverlay ? (
        <div data-testid={TestIds.overlay} className={anchorClassNames} />
      ) : (
        <Link
          className={anchorClassNames}
          href={href}
          target="_blank"
          rel="nofollow"
          onClick={() => shouldReportBi && onBannerClicked()}
        >
          <span className={styles.content} data-hook="freemium-text-mobile">
            {shouldUsePreferredApp ? (
              <PreferredAppContent
                translations={translations}
                preferredApp={preferredApp}
              />
            ) : (
              children
            )}
          </span>
        </Link>
      )}
    </div>
  ) : null;
};

export default FreemiumBannerMobileCommon;
